<div class="d-flex flex-row align-items-center flex-wrap float-end">
  @if (listLoader) {
    <div class="input-group input-group-sm me-2 w-auto">
      <label class="input-group-text" for="Zeilen">
        {{ "Zeilen" | translate }}
      </label>
      <select [(ngModel)]="listLoader.pageSize" class="form-control w-auto" id="Zeilen" name="Zeilen" required type="number">
        @for (size of listLoader?.availablePageSizes; track size) {
          <option>{{ size }}</option>
        }
      </select>
    </div>
  }
  <ng-content></ng-content>
</div>
